<section>
    <div>

        <!-- <div *ngIf="allowSaving && showSaveButtons" class="save-buttons">
            <app-saved-reports [userId]="userId" [accountId]="accountId"></app-saved-reports>

            <app-save-report [report]="report" [userId]="userId" [accountId]="accountId" [showSaveExistingReportButton]="clientReportLoaded"></app-save-report>
        </div> -->


        <div *ngIf="allowExportData && reportFinishedLoading" class="exportToPdfButton">
            <button id="ExportToPdfButton" class="btn btn-success" (click)="exportToPdf()"><i class="fa-solid fa-file-pdf"></i> Export to PDF</button>
        </div>

        <div *ngIf="showReportName && reportName" class="reportNameDiv">
            <h5 class="reportNameHeader">{{reportName}}</h5>
        </div>

        <div style="height: 850px;" id="report-container{{passedInReportId}}"></div>
    </div>
</section>